export default __webpack_public_path__ + "static/media/44.6884c53d.png";